import type { MouseEvent as ReactMouseEvent } from 'react';
import { useStoreApi } from '../../store';

/** Full-size background layer that receives pane gestures (pan, box select, double-click zoom) and right-clicks. */
export const Pane = () => {
  const store = useStoreApi();
  const handleContextMenu = (event: ReactMouseEvent) => store.getState().elementHandlers.onPaneContextMenu?.(event.nativeEvent);
  return <div className="cm-pane" onContextMenu={handleContextMenu} />;
};
